import { store } from "@escapio/portal/components/hotel-list/DataStore";
import connect from "@escapio/shared/data-store/connect";
import { Banner } from "./Banner";

customElements.define(
	"esc-stroer-banner-for-list",
	class extends connect(Banner, store) {
		constructor() {
			super();
			this.lastPage = undefined;
		}

		update(state) {
			if (this.lastPage === state.page) {
				return;
			}
			if (this.lastPage === undefined) {
				this.lastPage = state.page;
				return;
			}
			if (!this.isLoaded) {
				return;
			}
			this.refresh();
			this.lastPage = state.page;
		}
	},
);
